import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { setProgramType, setSelectedReduxNonDateBasedProgram } from '../../ducks/calendarActions';
import usePreSaveNavigationGuard from '../../hooks/usePreSaveNavigationGuard';

const ProgramContainer = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 18px;
  color: ${({ theme }) => theme.colors.text};
  padding-bottom: 10px;
  padding-left: 10px;
`;

const ProgramIconAndName = styled('div')`
  display: flex;
  align-items: center;
`;

const ProgramNameWrapper = styled('div')`
  cursor: pointer;
  display: flex;
  align-items: center;
  flex: 1;
`;

const ProgramName = styled('div')`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
`;

const CollapsibleProgram = ({
  program, isModal, closeModal,
}) => {
  const dispatch = useDispatch();
  const guardNavigation = usePreSaveNavigationGuard();

  const handleProgramClick = () => guardNavigation(() => {
    // Dispatch actions to set program type and select the program
    dispatch(setProgramType('free-form-program'));
    dispatch(setSelectedReduxNonDateBasedProgram(program));

    // Close modal if in modal context
    if (isModal && closeModal) {
      closeModal();
    }
  });

  return (
    <ProgramContainer>
      <ProgramIconAndName>
        <ProgramNameWrapper onClick={handleProgramClick}>
          <ProgramName>{program.programName}</ProgramName>
        </ProgramNameWrapper>
      </ProgramIconAndName>
    </ProgramContainer>
  );
};

CollapsibleProgram.propTypes = {
  program: PropTypes.instanceOf(Object).isRequired,
  isModal: PropTypes.bool,
  closeModal: PropTypes.func,
};

CollapsibleProgram.defaultProps = {
  isModal: false,
  closeModal: null,
};

export default CollapsibleProgram;
